import { Suspense } from 'react';
import LoadingSpinner from '@/components/LoadingSpinner';

interface SuspenseWrapperProps {
  children: React.ReactNode;
}

export const SuspenseWrapper = ({ children }: SuspenseWrapperProps) => (
  <Suspense fallback={<LoadingSpinner size='lg' className='h-40' />}>
    {children}
  </Suspense>
);
